module.exports = __webpack_public_path__ + "img/r-rachel-park-366508-unsplash-min.d6ba09be.jpg";